<template>
  <div :class="['page', $gameTemplateStyle.loadGamePage]">
    <div ref="headerContainer" :class="[$globalStyle.headerContainer]">
      <HeaderActionButton
        :text="$t('back')"
        :iconLink="leftArrowIcon"
        :clickFunction="goBack"
        backBg="#000000"
        frontBg="#676767"
        textColor="#FFFFFF"
        :icon-only="isMobile"
        :button-width="isMobile ? '60px' : isTablet ? '130px' : '160px'"
      />
      <div :class="[$globalStyle.header, $globalStyle.hostHeader]">
        <div :class="$globalStyle.headerLeft">
          <div :class="$globalStyle.logoContainer">
            <img :src="saboteurLogo" alt="icon" :class="$globalStyle.headerLogo" />
            <div :class="$globalStyle.headerTitle">{{ $t('saboteur') }}</div>
          </div>
        </div>
        <div :class="$globalStyle.headerRight">
          <!-- <div v-if="realTextIndex" :class="$globalStyle.headerItem">
              <div :class="$globalStyle.headerItemLabel">Original Text</div>
              <div :class="[$globalStyle.headerItemText, $globalStyle.headerItemHostSaboteurText]">
                Text {{ textIndexes[realTextIndex] }}
              </div>
            </div> -->
        </div>
      </div>
      <template v-if="!game">
        <HeaderActionButton
          :text="$t('reset')"
          :iconLink="resetIcon"
          :clickFunction="resetForm"
          backBg="#000000"
          frontBg="#676767"
          textColor="#FFFFFF"
          :rightIcon="true"
          :icon-only="isMobile"
          :button-width="isMobile ? '60px' : isTablet ? '130px' : '160px'"
        />
      </template>
    </div>
    <div :class="$gameTemplateStyle.bodyContainer">
      <template v-if="!game">
        <h1 :class="$gameTemplateStyle.bodyText">{{ $t('load-a-game') }}</h1>
        <div :class="$gameTemplateStyle.formContainer">
          <div :class="$gameTemplateStyle.form">
            <UtilInput
              :label="$t('join-code')"
              inputType="number"
              :iconLink="passwordKeyIcon"
              :placeholder="$t('enter-join-code')"
              :value="form.joinCode"
              @update:value="form.joinCode = $event"
            />
          </div>
        </div>
        <div :class="$gameTemplateStyle.ctaContainer">
          <UtilButton
            :text="$t('load-game')"
            :clickFunction="loadgame"
            size="lg"
            frontBg="#3F72AF"
            backBg="#112D4E"
            textColor="#FFFFFF"
            :button-width="isMobile ? '200px' : isTablet ? '220px' : '240px'"
          />
        </div>
      </template>
      <template v-if="game">
        <h1 :class="$gameTemplateStyle.bodyText">{{ $t('game-details') }}</h1>
        <div :class="$style.gameDetailsContainer">
          <div ref="lobbyWaitContainer" :class="$style.lobbyWaitContainer">
            <GameDetailsBox
              :host="game.host"
              :title="game.textTitle ?? ''"
              :discipline="game.discipline"
              :readingTime="game.readingTime"
              :discussionTime="game.discussionTime"
            />
          </div>
          <div ref="textsContainer" :class="$style.textsContainer">
            <GameTextsBox
              :texts="game.texts"
              :discipline="game.discipline"
              :codeLanguage="game.codeLanguage"
              :textTitle="game.textTitle"
              :realTextId="game.realTextId ? game.realTextId : null"
              :realTextLabel="game.realTextLabel ? game.realTextLabel : ''"
              :imageUrl="game?.imageUrl ?? ''"
              :showImageButton="true"
            />
          </div>
        </div>
        <div :class="$gameTemplateStyle.ctaContainer">
          <UtilButton
            :text="$t('copy')"
            :clickFunction="copyTemplate"
            size="lg"
            frontBg="#3F72AF"
            backBg="#112D4E"
            textColor="#FFFFFF"
            :iconLink="copyIcon"
            :rightIcon="true"
            :button-width="isMobile ? '200px' : isTablet ? '220px' : '240px'"
          />
        </div>
      </template>
    </div>
    <div></div>
    <div v-if="isLoading" :class="['loader-container']">
      <img :src="hostLoaderGif" alt="loader-gif" class="loader-gif" />
      <!-- <div :class="['loader']">Loading ...</div> -->
    </div>
    <UtilConfirmationModal
      :showModal="showCopyConfirmModal"
      :closeModal="cancelCopyGame"
      :title="$t('copy-game-title')"
      :secondaryText="$t('copy-game-description')"
      :primaryAction="confirmCopyGame"
      :secondaryAction="cancelCopyGame"
      :primaryActionText="$t('copy')"
      :secondaryActionText="$t('cancel')"
      :bgClickClose="false"
    />
  </div>


</template>

<script>
import styles from "@/css/LoadGameView.module.css";
import gameTemplateStyles from "@/css/GameViewTemplate.module.css";
import globalStyles from "@/css/global.module.css";
import UtilButton from "@/components/util/UtilButton.vue";
import SaboteurLogo from "../assets/saboteur-logo.svg";
import LeftArrowIcon from "@/assets/icons/left-arrow.svg";
import ResetIcon from "@/assets/icons/reset.svg";
import UtilInput from "@/components/util/UtilInput.vue";
import DetectiveHatIcon from "@/assets/icons/detective-hat.svg";
import PasswordKeyIcon from "@/assets/icons/password-key.svg";
import { toast } from "vue3-toastify";
// import gameService from "@/services/game.service";
import HostLoaderGif from "@/assets/gifs/host-loader.svg";
import { handleApiResponseError } from "@/utils/url";
import gameService from "@/services/game.service";
import { textLabels } from "@/utils/data";
import GameDetailsBox from "@/components/playGame/GameDetailsBox.vue";
import GameTextsBox from "@/components/playGame/GameTextsBox.vue";
import CopyIcon from "@/assets/icons/copy-white.svg";
import { useGameStore } from "@/stores/gameStore";
import HeaderActionButton from "@/components/buttons/HeaderActionButton.vue";
import useDeviceType from "@/utils/useDeviceType";
import UtilConfirmationModal from "@/components/util/UtilConfirmationModal.vue";

// import { handleApiResponseError } from "@/utils/url";
// import { useGameStore } from "@/stores/gameStore";

const device = useDeviceType();

export default {
  components: { UtilButton, UtilInput, GameDetailsBox, GameTextsBox, HeaderActionButton, UtilConfirmationModal },
  name: "LoadGameView",
  props: {},
  data() {
    return {
      saboteurLogo: SaboteurLogo,
      leftArrowIcon: LeftArrowIcon,
      resetIcon: ResetIcon,
      detectiveHatIcon: DetectiveHatIcon,
      passwordKeyIcon: PasswordKeyIcon,
      hostLoaderGif: HostLoaderGif,
      copyIcon: CopyIcon,
      isLoading: false,
      showCopyConfirmModal: false,
      form: {
        joinCode: null,
      },
      game: null,
    };
  },
  computed: {
    $style() {
      return styles;
    },
    $gameTemplateStyle() {
      return gameTemplateStyles;
    },
    $globalStyle() {
      return globalStyles;
    },
    width() {
      return device.width.value;
    },
    height() {
      return device.height.value;
    },
    isMobile() {
      return device.isMobile.value;
    },
    isTablet() {
      return device.isTablet.value;
    },
    isDesktop() {
      return device.isDesktop.value;
    },
  },
  methods: {
    calculateDynamicHeight() {
      this.$nextTick(() => {
        const headerHeight = this.$refs.headerContainer?.offsetHeight || 0;

        const totalFixedHeight = headerHeight;
        // console.log("totalFixedHeight: ", totalFixedHeight);
        // console.log("window.innerHeight: ", window.innerHeight);
        const remainingHeight = window.innerHeight - totalFixedHeight - 17;
        // console.log("remainingHeight: ", remainingHeight);

        // Set dynamic height for all sections
        if (!this.isMobile) {
          if (this.$refs.lobbyWaitContainer) {
            this.$refs.lobbyWaitContainer.style.height = `${remainingHeight}px`;
          }
          if (this.$refs.textsContainer) {
            this.$refs.textsContainer.style.height = `${remainingHeight}px`;
          }
        }
      });
    },
    getDefaultForm() {
      return {
        joinCode: null,
      };
    },
    resetForm() {
      // console.log("Resetting form...");
      const defaultForm = this.getDefaultForm();
      Object.keys(this.form).forEach((key) => {
        this.form[key] = defaultForm[key];
      });
    },
    goBack() {
      // console.log("go back clicked");
      this.$router.push({ name: "home", params: {} });
    },
    validateLoadGameForm() {
      if (!this.form.joinCode) {
        toast(this.$t("error-join-code"), {
          type: "error",
        });

        return false;
      }

      return true;
    },
    async loadgame() {
      try {
        // console.log("Join Game clicked");
        // check inputs provided
        // console.log("form: ", this.form);
        if (!this.validateLoadGameForm()) {
          return false;
        }

        // proceed to join game
        // console.log("make the api call!");

        this.isLoading = true;

        let loadGameResponse = await gameService.loadGame2({
          joinCode: parseInt(this.form.joinCode),
        });

        // console.log("loadGameResponse: ", loadGameResponse);
        if (
          loadGameResponse &&
          loadGameResponse.status === 200 &&
          loadGameResponse.data &&
          loadGameResponse.data.game
        ) {
          let gameData = loadGameResponse.data.game;
          gameData.imageUrl =gameData.imageUrl ?? "";

          let realTextId = null;
          let realTextLabel = "";
          let modifiedTexts = gameData.texts.map((text, index) => {
            if (text.isReal) {
              realTextId = parseInt(gameData.uniqueTextId[index]);
              realTextLabel = textLabels[index + 1];
            }

            return {
              id: gameData.uniqueTextId[index],
              label: textLabels[index + 1],
              content: text.content,
            };
          });

          gameData.texts = modifiedTexts;
          gameData.realTextId = realTextId;
          gameData.realTextLabel = realTextLabel;

          // Save game data in Pinia store
          //   let gameStoreData = {
          //     host: { id: parseInt(gameData.hostId), name: gameData.hostUsername },
          //     joinCode: gameData.joinCode,
          //     allowedPlayers: gameData.playerNum,
          //     readingTime: gameData.readingTime,
          //     discussionTime: gameData.discussionTime,
          //     textTitle: gameData.textTitle,
          //     discipline: getDisciplineKey(gameData.discipline),
          //     inaccuracyLevels: gameData.inaccuracyLevels ? gameData.inaccuracyLevels : {},
          //     originalText: gameData.originalText ? getFilteredText(gameData.originalText) : "",
          //     combinedText: gameData.originalText,
          //     codeLanguage: gameData.language ? gameData.language : "",
          //     llm: gameData.llm,
          //     enableFinalReason: gameData.enableVoteReason ? 1 : 0,
          //     enablePreliminaryReason: gameData.enablePreliminaryVoteReason ? 1 : 0,
          //     fbGameDocId: gameData.fbGameDocId,
          //     gameId: gameData.gameId,
          //     uniqueTextId: gameData.uniqueTextId,
          //     texts: modifiedTexts,
          //     realTextId: null,
          //     realTextLabel: "",
          //     phase: "JOIN",
          //   };
          //   console.log("gameStoreData: ", gameStoreData);
          this.game = gameData;
        } else {
          toast(this.$t("unexpected-error"), {
            type: "error",
          });
        }
      } catch (error) {
        handleApiResponseError(error);
      } finally {
        this.isLoading = false;
      }
    },
    copyTemplate() {
      this.showCopyConfirmModal = true;
    },
    confirmCopyGame() {
      this.showCopyConfirmModal = false;
      // console.log("copy this template");
      const gameStore = useGameStore();
      gameStore.setCopyGameJoinCode(this.game.joinCode);
      gameStore.setCopyGameSource(JSON.parse(JSON.stringify(this.game)));
      // Navigate to CopyGameView
      this.$router.push({ name: "copy-game" });
    },
    cancelCopyGame() {
      this.showCopyConfirmModal = false;
    },
  },
  mounted() {},
  beforeUnmount() {},
  setup() {},
  watch: {
    game: function () {
      this.$nextTick(() => {
        this.calculateDynamicHeight(); // Recalculate height after DOM updates
      });
    },
  },
};
</script>

<style scoped></style>
